var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeviceNotAllowed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 70,
    height: 69.671,
    viewBox: "0 0 70 69.671",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M95.782-822.185,44.925-873.042h46.5a6.329,6.329,0,0,1,4.642,1.931A6.329,6.329,0,0,1,98-866.469v39.437a6.458,6.458,0,0,1-.534,2.67A6.247,6.247,0,0,1,95.782-822.185ZM36.134-872.467v9.2L28-871.4l4.6-4.6,65.07,65.07-4.6,4.6L78.939-820.46h-.657v6.573H51.991v-6.573H38.845a6.329,6.329,0,0,1-4.642-1.931,6.329,6.329,0,0,1-1.931-4.642v-39.437a5.332,5.332,0,0,1,1.931-4.519Z",
    transform: "translate(-28 876)",
    fill: "#818181"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceNotAllowed);
export default __webpack_public_path__ + "static/media/device_not_allowed.f53396474509e5def3c92f89e1193151.svg";
export { ForwardRef as ReactComponent };